<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>站点管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="场地名称:">
        <el-select v-model="formInline.charging_stations_id" placeholder="请选择场地名称" clearable>
          <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备终端号" prop="serial_number">
          <el-input size="small" v-model="formInline.serial_number" auto-complete="off" placeholder="请输入设备终端号"></el-input>
        </el-form-item>
      <el-form-item label="是否已安装:"  clearable>
        <el-select v-model="formInline.is_fix">
          <el-option label="已安装" value="1"></el-option>
          <el-option label="未安装" value="0"></el-option>
        </el-select>
      <el-form-item label="设备类型:"  clearable></el-form-item>
        <el-select v-model="formInline.ac_dc" placeholder="请选择设备类型">
            <el-option v-for="item in ac_names" :label="item.name" :value="item.val" :key="item.val"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getdata()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="user.role_id == 39">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" width="100">
      </el-table-column>
      <el-table-column sortable prop="station_name" label="场地名称" width="150">
      </el-table-column>
      <el-table-column sortable prop="serial_name" label="设备名称" width="150">
      </el-table-column>
      <el-table-column sortable prop="company_name" label="供应商" width="150">
      </el-table-column>
      <el-table-column sortable prop="serial_number" label="设备终端号" width="200">
      </el-table-column>
      <el-table-column sortable prop="serial_number" label="枪数量 / 已添加" width="150">
        <template slot-scope="scope">
          {{ scope.row.gun_num }}/{{ scope.row.has_a_gun_status }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="ac_dc" label="设备类型" width="150">
        <template slot-scope="scope">
          {{ scope.row.ac_dc == '1' ? '慢充' :'快充'}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="rated_power" label="允许功率(kw)" width="150">
      </el-table-column>
      <el-table-column sortable prop="serial_imei" label="卡ICCID号" width="150">
      </el-table-column>
      <!-- <el-table-column sortable prop="serial_number" label="到期时间" width="200">
      </el-table-column>
      <el-table-column sortable prop="serial_number" label="续费价格(元)" width="200">
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="200" v-if="user.role_id == 39">
        <template slot-scope="scope">

          <el-button size="mini" type="primary" @click="reStartPile(scope.$index, scope.row)">重启</el-button>
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deletePile(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="场地名称" prop="charging_stations_id">
          <el-select v-model="editForm.charging_stations_id" placeholder="请选择场地名称" clearable>
            <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商名称" prop="serial_firm_id">
          <el-select v-model="editForm.serial_firm_id" placeholder="请选择供应商名称" clearable>
            <el-option v-for="item in suppliers_names" :label="item.company_name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称" prop="serial_name">
          <el-input size="small" v-model="editForm.serial_name"  placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="设备终端号" prop="serial_number">
          <el-input size="small" v-model="editForm.serial_number"  placeholder="请输入设备终端号"></el-input>
        </el-form-item>
        <el-form-item label="车位编号" prop="position_num">
          <el-input size="small" v-model="editForm.position_num"  placeholder="请输入车位编号"></el-input>
        </el-form-item>
        <el-form-item label="枪数量" prop="gun_total">
          <el-select v-model="editForm.gun_total" placeholder="请选择枪数量">
            <el-option  value="1" >1</el-option>
            <el-option  value="2" >2</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SIM卡号" prop="SIM_number">
          <el-input size="small" v-model="editForm.SIM_number"  placeholder="请输入SIM卡号"></el-input>
        </el-form-item>
        <el-form-item label="设备IMEI" prop="serial_imei">
          <el-input size="small" v-model="editForm.serial_imei"  placeholder="请输入设备IMEI"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="ac_dc">
          <el-select v-model="editForm.ac_dc" placeholder="请选择设备类型">
            <el-option v-for="item in ac_names" :label="item.name" :value="item.val" :key="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="额定电压 ( V )" prop="rated_voltage">
          <el-input size="small" v-model="editForm.rated_voltage"  placeholder="请输入额定电压"></el-input>
        </el-form-item>
        <el-form-item label="额定电流 ( A )" prop="rated_current">
          <el-input size="small" v-model="editForm.rated_current"  placeholder="请输入额定电流"></el-input>
        </el-form-item>
        <el-form-item label="额定功率 ( kW )" prop="rated_power">
          <el-input size="small" v-model="editForm.rated_power"  placeholder="请输入额定功率"></el-input>
        </el-form-item>
        <el-form-item label="网络类型" prop="net_type">
          <el-input size="small" v-model="editForm.net_type"  placeholder="请输入网络类型"></el-input>
        </el-form-item>
      <el-form-item label="设备状态:">
        <el-select v-model="editForm.pile_status" placeholder="请选择">
          <el-option v-for="item in status_names" :label="item.name" :value="item.val" :key="item.val"></el-option>
        </el-select>
      </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStationNames,getStation,addStation,updateStation,deleteStation } from '../../api/station'

import { getPile,addPile,updatePile,deletePile,reStartPile} from '../../api/pile'
import { getPrice,get_suppliers_name } from '../../api/price'

import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {
  pcaTextArr,
} from "element-china-area-data";
export default {
  data() {
    return {
      user:{},
      priceList:[],
      suppliers_names:[],
      pcaTextArr,
      selectedOptions: [],
      station_names:[],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        serial_firm_id: '',
        charging_stations_id: '',
        serial_name: '',
        serial_number: '',
        serial_imei: '',
        SIM_number: '',
        ac_dc: "2",
        gun_total: "1",
        net_type: '4G',
        rated_voltage: 'AC 220V±20%',
        rated_current: '0 ~ 32A',
        rated_power: '7',
        pile_status: 1,
        position_num: '',
      },
      status_names:[{name:'启用',val:1},{name:'停用',val:0}],
      ac_names:[{name:'快充',val:2},{name:'慢充',val:1}],
      // rules表单验证
      rules: {
        serial_firm_id: [
          { required: true, message: '请选择供应商名称', trigger: 'blur' }
        ],

        charging_stations_id: [
          { required: true, message: '请选择场地名称', trigger: 'blur' }
        ],
        serial_name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        serial_number: [
          { required: true, message: '请输入设备', trigger: 'blur' }
        ],
        serial_imei: [
          { required: true, message: '请输入设备IMEI', trigger: 'blur' }
        ],
        SIM_number: [
          { required: true, message: '请输入SIM卡号', trigger: 'blur' }
        ],
        position_num: [
          { required: true, message: '请输入车位编号', trigger: 'blur' }
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        charging_stations_id: '',
        is_fix: '',
        serial_number:'',
        ac_dc:'',
      },
      // 删除部门
      seletedata: {
        ids: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    this.getStationNames()
    this.get_suppliers_name()
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    get_suppliers_name(){
      get_suppliers_name().then(res => {
        if (res.code == 0) {
            this.suppliers_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 获取公司列表
    getdata() {
      this.loading = true
      getPile(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.serial_firm_id = row.serial_firm_id
        this.editForm.charging_stations_id = row.charging_stations_id
        this.editForm.serial_name = row.serial_name
        this.editForm.serial_number = row.serial_number
        this.editForm.serial_imei = row.serial_imei
        this.editForm.ac_dc = row.ac_dc
        this.editForm.gun_total = row.gun_total
        this.editForm.net_type = row.net_type
        this.editForm.rated_voltage = decodeURI(encodeURI(row.rated_voltage)),
        this.editForm.rated_current = row.rated_current
        this.editForm.rated_power = row.rated_power
        this.editForm.position_num = row.position_num
        this.editForm.pile_status = row.pile_status
        this.editForm.SIM_number = row.SIM_number
        this.editForm.id = row.id
      } else {
        this.title = '添加'
        this.editForm =  {
          serial_firm_id: '',
          charging_stations_id: '',
          serial_name: '',
          serial_number: '',
          serial_imei: '',
          SIM_number: '',
          ac_dc: "2",
          gun_total: "1",
          net_type: '4G',
          rated_voltage: "AC 220V±20%",
          rated_current: "0 ~ 32A",
          rated_power: '7',
          pile_status: 1,
          position_num: '',
        }
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id){
            updatePile(this.editForm.id,this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }else{
            addPile(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    reStartPile(index, row) {
      this.$confirm('此操作将重启设备, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          reStartPile({serial_number:row.serial_number})
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已下发!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('重启失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重启'
          })
        })
    },
    deletePile(index, row) {
      this.$confirm('此操作将删除该场地, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deletePile(row.id)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/pile/Pile.vue